<div class="dialog-container">
  <h3 class="dialog-title">{{ 'MM.attachment.androidFileChoiceDialog.title' | translate }}</h3>
  <button class="option-btn" (click)="choose('camera')">{{ 'MM.attachment.androidFileChoiceDialog.camera' | translate }}</button>
  <button class="option-btn" (click)="choose('file')">{{ 'MM.attachment.androidFileChoiceDialog.file' | translate }}</button>
  <button class="cancel-btn" (click)="close()">{{ 'MM.general.button.cancel' | translate }}</button>
</div>